import React from "react";
import { useNavigate } from "react-router-dom";
import "./CheckoutPage.css";

const CheckoutPage = ({ cartItems, clearCart }) => {
  const navigate = useNavigate();

  // ✅ Calculate total price
  const total = cartItems
    .reduce((sum, item) => sum + (item.price || 0), 0)
    .toFixed(2);

  const handlePlaceOrder = () => {
    // ✅ Pass the current cart items to OrderComplete page
    navigate("/order-complete", { state: { orderItems: cartItems, total } });

    // ✅ Clear the cart AFTER navigation (slight delay)
    setTimeout(() => clearCart(), 100);
  };

  return (
    <div className="checkout-page">
      <h2>Checkout</h2>

      {cartItems.length > 0 ? (
        <>
          <ul className="checkout-list">
            {cartItems.map((item, index) => (
              <li key={index} className="checkout-item">
                {item.name} - ${item.price.toFixed(2)}
              </li>
            ))}
          </ul>

          {/* ✅ Show total below the list */}
          <div className="checkout-total">
            <strong>Total:</strong> ${total}
          </div>

          <button onClick={handlePlaceOrder} className="place-order-btn">
            Place Order
          </button>
        </>
      ) : (
        <p>Your cart is empty.</p>
      )}
    </div>
  );
};

export default CheckoutPage;
